module.exports = __webpack_public_path__ + "img/home_live_stage.4aee4ced.png";